import styled from 'styled-components';

import { colors } from 'global/colors';

export const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  margin: 0;
`;
export const EditorContainer = styled.div`
  height: calc(100% - 30px);
  width: 100%;
  overflow: hidden;
  span.ace_comment {
    color: ${({ theme }) => theme.ace.comment};
  }
`;

export const CreatorTabContentBackground = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;

  color: ${({ theme }) => theme.text};

  & :is(h1, h2, h3, h4, h5, h6) {
    color: ${({ theme }) => theme.header};
  }
  & input,
  & label,
  & p {
    color: ${({ theme }) => theme.text};
  }

  & input {
    background-color: ${({ theme }) => theme.pageBackground};
    border-color: ${colors.gray};
  }
  & input:disabled {
    background-color: ${({ theme }) => theme.pageBackground};
    border-color: ${colors.gray};
  }
`;
